import React from "react";
import "./MissionCard.css";

const MissionCard = ({ frontTitle, frontText, backTitle, backText }) => {
  return (
    <div className="mission-card p-4">
      <h3 style={{ color: "#ecb003" }}>{frontTitle}</h3>
      <div className="mission-description">
        <h4>{frontText}</h4>
        {backTitle ? <p>{backTitle}</p> : null}
        {/* <div className="icon-text">
          <div className="icon-circle mb-3">📍</div>
          <p className="back-text">{backText}</p>
        </div> */}
      </div>
    </div>
  );
};

export default MissionCard;
